import React from 'react';
import {Link} from 'react-router-dom'
import {Drawable} from "../../../../../res/images/Drawable";

interface States {

}

interface Props {
}

class AppIcon extends React.Component<Props, States> {

    state: States

    constructor(props: Props) {
        super(props)
        this.state = {}

    }

    render() {
        return (
            <div>
                <Link to="/">
                    <img
                        className="appIcon"
                        src={Drawable.appIcon}/>
                </Link>
            </div>
        )
    }
}

export default AppIcon;
